import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'
import PanelComprasComponent from '../PanelCompras/PanelComprasComponent'

{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../../img/logoBlancoSVG2.svg';
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesaHolograma.module.css'; { {/*Estilos para el componente*/ } }

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar, faWrench,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesaHolograma from './BotonMenuHamburguesaHolograma';

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar, faWrench)
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import { useDispatch, useSelector } from 'react-redux'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import ListAltIcon from '@mui/icons-material/ListAlt';

import { obtenerSolicitudesEntregas } from '../../../redux/DuckPanelHologramas/ModuloEntregasDuck'
import { obtenerInventarios } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck'
import { obtenerSolicitudesCompraFinanzas, obtenerSolicitudesCompraHologramas } from '../../../redux/DuckPanelHologramas/ModuloComprasDuck'

const MenuHamburguesaHolograma = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '36px'
        },
        bmBurgerBars: {
            background: 'white'
        },
        bmBurgerBarsHover: {
            background: 'green'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: 'white'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            backgroundColor: '#0D717C',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: 'white',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }
    const dispatch = useDispatch()
    const currentUser = useSelector(store => store.Usuario.data)
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }
    const dataUser = useSelector(store => store.Usuario.user)
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row text-center'>
                        <div className='col-10'>
                            <div className='row'>
                                <div className='col-4'></div>
                                <div className='col-7 mt-2' style={{ textAlign: 'center', fontSize: '10px !important' }}>
                                    {dataUser?.[0]?.idtipousuario == 9 &&
                                        <span className='textoEscondido text-center text-light'>
                                            <strong>PANEL DE HOLOGRAMAS</strong><br />
                                            <Box display="flex" justifyContent="center" width="100%">
                                                <Tabs value={value} onChange={handleChange}
                                                    aria-label="icon tabs example"
                                                    variant='scrollable'
                                                    scrollButtons={true}
                                                    allowScrollButtonsMobile={true}
                                                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}

                                                    sx={{
                                                        "& button": { color: 'white' },
                                                        "& button:hover": { color: 'white', transform: 'scale(1.1)' },
                                                        "& button.Mui-selected": { backgroundColor: '#E3EFF1', color: '#0D717C', borderTopLeftRadius: 5, borderTopRightRadius: 5 },
                                                    }}>
                                                    <Tab label="Compras" icon={<AddShoppingCartIcon />} iconPosition="start" value="1"
                                                        onClick={() => {
                                                            props.history.push('/PanelComprasComponent')
                                                            dataUser?.[0]?.idtipousuario == 10 ? dispatch(obtenerSolicitudesCompraFinanzas()) :
                                                                dataUser?.[0]?.idtipousuario == 9 ? dispatch(obtenerSolicitudesCompraHologramas()) : ''
                                                        }} />
                                                    <Tab label="Entregas" icon={<SendTimeExtensionIcon />} iconPosition="start" value="2"
                                                        onClick={() => {
                                                            props.history.push('/PanelEntregasComponent')
                                                            dispatch(obtenerSolicitudesEntregas())
                                                        }} />
                                                    <Tab label="Inventarios" icon={<ListAltIcon />} iconPosition="start" value="3"
                                                        onClick={() => {
                                                            props.history.push('/PanelInventariosComponent')
                                                            dispatch(obtenerInventarios())
                                                        }} />
                                                </Tabs>
                                            </Box>
                                        </span>
                                    }
                                    {dataUser?.[0]?.idtipousuario == 10 &&
                                        <span className='textoEscondido text-center text-light'><strong>PANEL DE FINANZAS</strong><br />
                                            <Tabs value={value} onChange={handleChange} centered aria-label="icon tabs example"
                                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                                sx={{
                                                    "& button": { color: 'white' },
                                                    "& button:hover": { color: 'white', transform: 'scale(1.1)' },
                                                    "& button.Mui-selected": { backgroundColor: '#E3EFF1', color: '#0D717C', borderTopLeftRadius: 5, borderTopRightRadius: 5 }
                                                }}>
                                                <Tab label="Compras" icon={<AddShoppingCartIcon />} iconPosition="start" value="1"
                                                        onClick={() => {
                                                            props.history.push('/PanelComprasComponent')
                                                            dataUser?.[0]?.idtipousuario == 10 ? dispatch(obtenerSolicitudesCompraFinanzas()) :
                                                                dataUser?.[0]?.idtipousuario == 9 ? dispatch(obtenerSolicitudesCompraHologramas()) : ''
                                                        }} />
                                            </Tabs>
                                        </span>
                                    }
                                </div>

                            </div>
                        </div>
                        <div className='col-2 mt-3' style={{ textAlign: 'right', paddingRight: '4%', paddingTop: '1%' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: 'transparent', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>
                        </div>
                    </header>
                </Fragment>
            </div>

            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    <Fragment>
                        <BotonMenuHamburguesaHolograma titulo="Panel compras" objeto={[]} ruta="/PanelComprasComponent"></BotonMenuHamburguesaHolograma>
                        {dataUser?.[0]?.idtipousuario == 9 &&
                            <Fragment>
                                <BotonMenuHamburguesaHolograma titulo="Panel entregas" objeto={[]} ruta="/PanelEntregasComponent"></BotonMenuHamburguesaHolograma>
                                <BotonMenuHamburguesaHolograma titulo="Panel de inventarios" objeto={[]} ruta="/PanelInventariosComponent"></BotonMenuHamburguesaHolograma>
                            </Fragment>

                        }
                    </Fragment>
                </List>
            </Menu>

            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
        </Fragment >
    );
};

export default withRouter(MenuHamburguesaHolograma)
